export default __webpack_public_path__ + "static/lamiantiskid-b6f7b46cf166931cb8d40a7a7dead369.jpg";